import React, { Fragment, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import StyledGlobal from './styles/StyledGlobal';
import NavigationBar from './container/navigation/NavigationBar';
import Layout from './component/Layout';
import SubFooter from './container/navigation/SubFooter';
import Footer from './container/navigation/Footer';
import ContentRouter from './routing/ContentRouter';
import ContextApi from './ContextApi';
import newsLetterData from './newsLetterData';


function App() {
  const [auth, setAuth] = useState(localStorage.getItem('token') ? true : false);
  const user = JSON.parse(localStorage.getItem('user'));
  const [moviecartList, setMoviecartList] = useState([]);
  const [screeningRoomList, setScreeningRoomList] = useState([]);
  const [newsPost] = useState(newsLetterData);


  return (
    <Fragment>
      <ContextApi.Provider
        value={{
          auth,
          setAuth,
          user,
          moviecartList,
          setMoviecartList,
          screeningRoomList,
          setScreeningRoomList,
          newsPost
          
        }}>
        <Router>
            <NavigationBar />
          <div>
              <Layout>
                <ContentRouter />
              </Layout>
              <SubFooter />
          </div>
            <Footer />
        </Router>
        <StyledGlobal />
      </ContextApi.Provider>
    </Fragment>
  )
};

export default App;